import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MagneticButton from "@/components/MagneticButton";

/** Reusable inline CTA banner used on most inner pages. */
export default function CTABand({ headline, sub, primary = { label: "Book Strategy Call", to: "/contact" }, secondary }) {
  return (
    <section className="section relative" data-testid="cta-band">
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl glass-strong p-9 sm:p-12"
        >
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full blur-3xl opacity-30 bg-gradient-to-tr from-neon-magenta via-neon-orange to-neon-cyan" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full blur-3xl opacity-20 bg-gradient-to-tr from-neon-cyan to-neon-purple" />
          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-7">
            <div className="max-w-2xl">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
                {headline}
              </h2>
              {sub && <p className="mt-3 text-white/65 max-w-xl">{sub}</p>}
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to={primary.to}>
                <MagneticButton tone="warm" data-testid="cta-band-primary">
                  {primary.label} <ArrowRight size={16} />
                </MagneticButton>
              </Link>
              {secondary && (
                <Link to={secondary.to}>
                  <MagneticButton tone="ghost" data-testid="cta-band-secondary">
                    {secondary.label}
                  </MagneticButton>
                </Link>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
